export default __webpack_public_path__ + "media/images/main-adv/digital-mobile-2061e46080407ea783fa4152ebf36384.svg";